module.exports = __webpack_public_path__ + "media/images/workplace/social-ico/apple-ico-dark-471d497da0cbe3a9240595e401ab3890.svg";